export const APP_PATHS = {
  home: '/',
  login: '/login',
  register: '/register',
  resetPassword: '/reset-password',
  profile: '/profile',
  addActivity: '/add-activity',
  post: '/post',
  challenge: '/challenge',
  videos: '/videos',
  addVideo: '/add-video',
  help: '/help',
  feedback: '/feedback',
  community: '/community',
  coach: '/coach-gpt',
  coachResponse: '/coach-gpt/response',
  admin: '/admin',
  signUp: '/sign-up',
};
